<style lang="scss" scoped>
</style>
<template>
    <div>
        <private-table :pageHide="true" class="m-t-20" :columnsList="tableColumns" :dataTable="dataTable"></private-table>
        <Modal
            :title="'输入密码'"
            v-model="userInfo"
            width="500"
            class="baseInfo-modal"
            :styles="{top: '220px'}">
        <Form :label-width="80" ref="addForm" :rules="rules" :model="form">
            <Row :gutter="60">
                <Col span="24" class="m-t-20">
                <FormItem label="账号密码" prop="password">
                    <Input type="text" v-model="form.password" placeholder="账号密码"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="text" size="large" @click="userInfo = !userInfo">取消</Button>
            <Button type="primary" size="large" @click="asyncOK">确定</Button>
        </div>
    </Modal>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
    import privateTable from './private-table.vue';
    // 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'wit-control',
        props: {
            id: ''
        },
        data() {
            return {
                loginData: {},
                day: 'today',
                lineData: {
                    x: [],
                    y: [],
                },
                lodeTime: '',
                tableColumns: [],
                dataList: [],
                pointId: '',
                pointValue: '',
                userInfo: false,
                page: {
                    totalCount: 0,
                    pageSize: 10,
                    currentPage: 1
                },
                form: {
                    password: '',
                },
                rules: {
                    password: [{required: true, message: '账号密码不能为空', trigger: 'blur'}]
                },
                tableColumns: [
                    {title: '测点名称', key: 'name'},
                    {
                        title: '当前状态', 
                        key: 'pointValue',
                        render: (h, params)=>{
                            let text = '开'
                            if(params.row.pointValue == '1'){
                                text = '开'
                            }else {
                                text = '关'
                            }
                            return h('div', {}, text);
                        }
                    },
                    {
                        title: '控制按钮',
                        key: 'reservePlanTypeName',
                        render: (h, params) => {
                            let erasure = h('Button', {
                                props: {
                                    type: params.row.pointValue == 1 ? 'primary' : 'default',
                                    shape: "circle",
                                    icon: 'md-power',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.userInfo = true;
                                        this.pointId = params.row.id;
                                        this.pointValue = params.row.pointValue;
                                        this.form.password = '';
                                    }
                                }
                            })
                            return h('div', {}, [
                                erasure
                            ]);
                        }
                    }
                ],
                dataTable: {},
            };
        },
        mounted() {
            this.getTable();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
             //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
            getTable() {
                let url = `/mcbw/network_monitor/switch_catalog`;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                        partId:this.id,
                        button: 'all',
                        pageSize: 1000,
                        currentPage: 1
                    }
                };

                return new Promise((resolve, reject) => {
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            console.log(res);
                            
                            this.list = res.data.data.data;
                            this.page.totalCount = res.data.totalCount ? res.data.totalCount : 0;
                            this.dataTable = {
                                list: this.list,
                                page: this.page,
                            }
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            asyncOK () {
                this.$refs['addForm'].validate((valid) => {
                    return new Promise((resolve, reject) => {
                        if (valid) {
                            
                            let url = '/mcbw/network_monitor/switch_control';
                            let _this = this;
                            var data = {
                                type: 'get',
                                url: url,
                                obj: {
                                    orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                                    pointId: this.pointId,
                                    pointValue: this.pointValue,
                                    passWord: this.form.password,
                                }
                            };
                            _this.$Axios(data).then((response) => {
                                if (response.data.success) {
                                    console.log(response);
                                    
                                    this.userInfo = !this.userInfo;
                                    this.$Message.success(response.data.message);
                                    this.getTable();
                                }else{
                                    this.userInfo = !this.userInfo;
                                     this.$Message.error(response.data.message);
                                }
                                resolve()
                            }).catch(err => {
                                reject(err)
                            })
                        }
                    })
                })
            },
        },
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart,
            privateTable
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/wit-electric-monitor/wit-control.vue